
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import conf from "./../../config/base.js";
import {

invoiceTitleType
} from "@/common/js/const.js";

import regexpValid from "@/common/js/regexp.js";
import Box from 'vux/src/components/box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Search from 'vux/src/components/search/index.vue'


export default {

components: {
Box,
Group,
XSwitch,
Cell,

Checker,
CheckerItem,

XHeader,
XButton,
XInput,
XTextarea,
Search
},
data() {
return {
isWechat: ____isWechatBrowser(),
topHeight: ____hasHeader ? "46px" : "0px",
searchResults: [],
showSearch: false,
disableSaveBtn: true,
invoiceTitleType: invoiceTitleType,
invoiceTitle: {
name: "",
type: 0, //0个人  1企业
taxNumber: "",
bank: "",
bankAccount: "",
tel: "",
address: "",
email: "",
default: false
},

validTaxNumber(val) {
if (regexpValid.taxNumber(val)) {
return { valid: true, msg: "" };
} else {
return { valid: false, msg: this.$t("税号有误") };
}
},

validInvoiceTitle(val) {
if (regexpValid.invoiceTitle(val)) {
return { valid: true, msg: "" };
} else {
return { valid: false, msg: this.$t("抬头长度小于100") };
}
}
};
},
created() {},
activated() {
var $self = this;
$self.pageLoad();
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {
var $self = this;

},
methods: {
resetForm() {
var $self = this;
$self.invoiceTitle = {
name: "",
type: 1, //0个人  1企业
taxNumber: "",
bank: "",
bankAccount: "",
tel: "",
address: "",
email: "",
default: false
};




},

pageLoad() {
var $self = this;
$self.invoiceTitle.type = $self.invoiceTitleType.company;




$self.resetForm();

if ($self.isWechat) {

$self.$webapi.getJsapiSign().then(res => {
$self.$clog(res.data);
window.wx.config({
beta: true,
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.data.appId, // 必填，公众号的唯一标识
timestamp: res.data.timestamp, // 必填，生成签名的时间戳
nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
signature: res.data.signature, // 必填，签名，见附录1
jsApiList: [

"chooseInvoiceTitle"
]
});
});
}
},

useWechatTitle() {
var $self = this;
if ($self.isWechat) {
window.wx.ready(function() {
window.wx.invoke(
"chooseInvoiceTitle",
{
scene: "1"
},
function(res) {
var wxTitle = JSON.parse(res.choose_invoice_title_info);
var title = {
name: wxTitle.title,
taxNumber: wxTitle.taxNumber,
bank: wxTitle.bankName,
bankAccount: wxTitle.bankAccount,
address: wxTitle.companyAddress,
tel: wxTitle.telephone,
email: "",
type: 0,
default: false
};
$self.invoiceTitle = title;
}
);
});
}
},

save() {
var $self = this;


var isValid = !(
(($self.$refs.input_invoice_title_name.valid == false ||
$self.$refs.input_tax_number.valid == false ||
$self.$refs.input_email.valid == false ||
$self.$refs.input_tel.valid == false) &&
$self.invoiceTitle.type == $self.invoiceTitleType.company) ||
(($self.$refs.input_invoice_title_name.valid == false ||
$self.$refs.input_tax_number2.valid == false ||
$self.$refs.input_email.valid == false ||
$self.$refs.input_tel.valid == false) &&
($self.invoiceTitle.type == $self.invoiceTitleType.person ||
$self.invoiceTitle.type == $self.invoiceTitleType.nonbusiness))
);



if (!isValid) {
$self.$vux.toast.show({
text: $self.$t("表单验证失败提示"),
type: "text"
});
return false;
}
$self.$webapi
.createInvoiceTitle({
name: $self.invoiceTitle.name,
taxerId: $self.invoiceTitle.taxNumber,
bankName: $self.invoiceTitle.bank,
bankAccount: $self.invoiceTitle.bankAccount,
companyAddr: $self.invoiceTitle.address,
companyPhone: $self.invoiceTitle.tel,
email: $self.invoiceTitle.email,
isSpecialInvoice: $self.invoiceTitle.type + "", //是否专票抬头
isVerified: "0", //是否验真抬头
isDefault: $self.invoiceTitle.default ? "1" : "0"
})
.then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {

$self.$vux.toast.show({
text: $self.$t("操作成功"),
type: "text"
});


setTimeout(function() {
$self.$router.replace("/invoicetitle");
}, 800);
}
});
},
setSearchFocus() {
var $self = this;
$self.showSearch = true;
this.$refs.search.setFocus();
setTimeout(() => {
this.$refs.search.setFocus();
}, 100);
setTimeout(() => {
this.$refs.search.setFocus();
}, 600);
},
setSearchBlur() {
var $self = this;


},
searchResultClick(item) {
var $self = this;
$self.showSearch = false;


if (item.other < 1) {
$self.invoiceTitle.name = item.title;
return false;
}
var titleId = item.other;
$self.$webapi.getTitleInfoByIdFrom16(titleId).then(res => {
$self.$clog(res.data);







if (res.data.status == null) {
$self.invoiceTitle.name = res.data.name;
$self.invoiceTitle.taxNumber = res.data.taxNo;
$self.invoiceTitle.bank = res.data.bankName;
$self.invoiceTitle.bankAccount = res.data.bankAccount;
$self.invoiceTitle.address = res.data.address;
$self.invoiceTitle.tel = res.data.phone;
}
});
},

searchGetResult(val) {
var $self = this;
var titleName = $self.invoiceTitle.name;
$self.$webapi.getTitleNameFrom16(titleName).then(res => {
$self.$clog(res.data);

var resultList = [
{
title: titleName,
other: -1
}
];


if (res.data instanceof Array || res.data.status == null) {
if (res.data.length > 0) {
resultList = res.data.map(el => {
return {
title: el.name,
other: el.id
};
});
}
}
$self.searchResults = resultList;
});
},
onSearchSubmit() {
var $self = this;
this.$refs.search.setBlur();





},
onSearchFocus() {
var $self = this;

},
onSearchCancel() {
var $self = this;

$self.showSearch = false;
}
}
};
